import Mock from 'mockjs'
//引入数据
import homeApi from './mockServeData/home'
Mock.mock('/api/home/getData', 'get', homeApi.getStatisticalData)
import userApi from './mockServeData/user'
//mock模拟后台数据
Mock.mock(/api\/user\/getUser/, "get", userApi.getUserList)
Mock.mock('/api/user/del', "post", userApi.deleteUser)
Mock.mock('/api/user/edit', "post", userApi.updateUser)
Mock.mock('/api/user/add', "post", userApi.createUser)